import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Lottie from 'react-lottie-player';
import { useNavigate } from 'react-router-dom';
import { useChallenge } from 'src/hook/data/useChallenge';
import { getRandomPraise } from 'src/utils/PraiseUtils';
import { GetWellDoneLottieUrl } from 'src/utils/URLUtils';
import styles from './WellDone.module.scss';

const WellDone = () => {
    const { t } = useTranslation();

    const lottieUrl = useMemo(() => GetWellDoneLottieUrl(), []);
    const praise = useMemo(() => getRandomPraise(), []);
    const navigate = useNavigate();
    const { setIsFiltered, setSelectedLists } = useChallenge();

    const handleContinue = () => {
        setIsFiltered(false);
        setSelectedLists([]);
        navigate(`/`);
    }

    return (
        <div className={styles.wellDone}>
            <div className={styles.lottieContainer}>
                <Lottie
                    path={lottieUrl}
                    loop={true}
                    play
                    className={styles.lottie}
                />
            </div>

            <h1 className={styles.praise}>{praise}</h1>
            <p>{t("You've completed your daily reviews.")}</p>
            <button
                className='turquoiseButton'
                onClick={handleContinue}
            >{t('Keep It Up')}</button>
        </div>
    );
};

export default WellDone;
